// extracted by mini-css-extract-plugin
export default {"mainTitle":"Hero_mainTitle__0Y+e+","info":"Hero_info__Wyo9X","heroImg":"Hero_heroImg__saZEV"};